import {
  SHOW_PASSWORD_RESET_SUCCESS_MODAL,
  HIDE_PASSWORD_RESET_SUCCESS_MODAL,
  AppAction,
} from '../../actions/app';

export interface State {
  email?: string;
}

const initialState: State = {};

type Action = AppAction;

export default (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case SHOW_PASSWORD_RESET_SUCCESS_MODAL:
      return {
        ...state,
        email: action.payload.email,
      };
    case HIDE_PASSWORD_RESET_SUCCESS_MODAL:
      return initialState;

    default:
      return state;
  }
};
